import * as React from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TableHead } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import ArrowRightIcon from '../../../../assets/icons/Arrows-chevron/Arrow-Right.svg'
import { capitalize } from '../../../../utils/functions'
import { CourseAnalyticState } from '../../../../features/types'
import { ui } from '../../../../utils/uiTokens'

interface Props {
    analyticsData: CourseAnalyticState[]
    isFetching: boolean
}

const AnalyticsTable: React.FC<Props> = ({
    analyticsData = [],
    isFetching,
}) => {
    const { formatMessage, locale } = useIntl()

    return (
        <Box>
            <TableContainer
                component={Paper}
                sx={{ border: 1, borderColor: 'grey.100', borderRadius: 2 }}
                elevation={0}
            >
                <Table
                    sx={{ minWidth: 500 }}
                    aria-label="custom pagination table"
                >
                    <TableHead sx={{ bgcolor: 'grey.100' }}>
                        <TableRow>
                            <TableCell>#</TableCell>

                            <TableCell>
                                {formatMessage({ id: 'course' })}
                            </TableCell>

                            <TableCell>
                                Жалпы оқып жатқандар саны
                            </TableCell>

                            <TableCell>
                                Қазақша оқып жатқандар саны
                            </TableCell>

                            <TableCell>
                                Орысша оқып жатқандар саны
                            </TableCell>

                            <TableCell>
                                Пәндер аналитикасы
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    {analyticsData?.length ? (
                        <TableBody>
                            {analyticsData?.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {index + 1}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row?.[`courseTitle${capitalize(locale)}`]}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row?.totalCount}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {row?.totalCountKz}
                                    </TableCell>

                                    <TableCell
                                        component="th"
                                        scope="row"
                                    >
                                        {
                                            row?.totalCountRu
                                        }
                                    </TableCell>

                                    <TableCell
                                        style={{ width: 60 }}
                                        align="center"
                                    >
                                       <Link
                                            to={`${row?.id}`}
                                            state={{
                                                course: row,
                                            }}
                                        >
                                            <IconButton sx={{ background: ui.track }}>
                                                <img
                                                    src={ArrowRightIcon}
                                                    alt="details"
                                                />
                                            </IconButton>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    ) : (
                        !isFetching && (
                            <TableBody>
                                <TableRow>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        colSpan={7}
                                    >
                                        {formatMessage({ id: 'noData' })}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        )
                    )}

                </Table>
            </TableContainer>
        </Box>
    )
}

export default AnalyticsTable
